import { Sync as RefreshIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

interface Props {
  onRefresh: () => void;
}

export function RefreshWithTextButton({ onRefresh }: Props) {
  return (
    <Button
      variant="text"
      size="small"
      startIcon={<RefreshIcon />}
      onClick={onRefresh}
      sx={{
        color: "primary.main",
        textTransform: "none",
        fontSize: "0.875rem",
        fontWeight: 500,
      }}
    >
      Refresh
    </Button>
  );
}
